import { useContext, useEffect } from "react"
import XmppPubSubApi from "@/api/xmppPubSubApi"
import { XmppContext } from "@/stream/xmppClient"
import { useAppDispatch } from "@/reducers/hooks"
import { updateRouteConfig } from "@/reducers/routes2gSlice"

const fetchedRouteJids = new Set<string>()
const inFlightRouteJids = new Set<string>()

export const useEnsureCarConfigLoaded = (
  routeJid: string | null | undefined,
) => {
  const { client } = useContext(XmppContext)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!client || !routeJid) return
    if (fetchedRouteJids.has(routeJid)) return
    if (inFlightRouteJids.has(routeJid)) return

    inFlightRouteJids.add(routeJid)
    XmppPubSubApi.fetchCarConfig(client, routeJid)
      .then((config) => {
        if (config) {
          dispatch(updateRouteConfig({ jid: routeJid, config }))
        } else {
          // Empty/missing config — write a sentinel so selectors can
          // distinguish "loaded but empty" from "not yet loaded".
          dispatch(updateRouteConfig({ jid: routeJid, config: {} }))
        }
        fetchedRouteJids.add(routeJid)
      })
      .catch(() => {
        // Leave neither set populated; allow later retry on a fresh mount.
      })
      .finally(() => {
        inFlightRouteJids.delete(routeJid)
      })
  }, [client, routeJid, dispatch])
}
